import { jsx as s, Fragment as m, jsxs as n } from "react/jsx-runtime";
import * as a from "react";
import c from "./generated/mistica-icons/icon-close-regular.js";
import { useTheme as b } from "./hooks.js";
import u from "./icon-button.js";
import { vars as d } from "./skins/skin-contract.css-mistica.js";
import { dismissableContainer as f, dismissableButton as p, dismissableCircleContainer as h } from "./maybe-dismissable.css-mistica.js";
const i = /*#__PURE__*/ a.createContext(!1), I = ()=>a.useContext(i), x = (param)=>{
    let { children: e , width: r , onClose: t , "aria-label": o  } = param;
    const { texts: l  } = b();
    return t ? /* @__PURE__ */ n("section", {
        className: f,
        "aria-label": o,
        style: {
            width: r || "100%"
        },
        children: [
            /* @__PURE__ */ s(i.Provider, {
                value: !0,
                children: e
            }),
            /* @__PURE__ */ s(u, {
                className: p,
                onPress: t,
                "aria-label": l.closeButtonLabel,
                style: {
                    display: "flex",
                    width: 48,
                    height: 48
                },
                children: /* @__PURE__ */ s("div", {
                    className: h,
                    children: /* @__PURE__ */ s(c, {
                        color: d.colors.neutralHigh
                    })
                })
            })
        ]
    }) : /* @__PURE__ */ s(m, {
        children: e
    });
}, N = x;
export { N as default, I as useIsDismissable };
